import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const PratiqueLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto">
        <Outlet /> {/* 👈 Affiche les sous-routes ici */}
      </div>
    </div>
  );
};

export default PratiqueLayout;
